<div class="d-flex flex-column align-items-center justify-content-center">
    <h2>La page que vous cherchez n'existe pas !</h2>
    <img src="../../assets/img/404.jpg" alt="Iron Man blessé" class="mb-5">
</div>